module.exports = __webpack_public_path__ + "media/recipes/106-4024c463.png";